import { useInfiniteQuery } from "@tanstack/react-query";
import PostListItem from "../PostListItem/PostListItem";
import api from "../../../../api/axiosInstance";
import LoadMoreTrigger from "./LoadMoreTrigger";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const fetchPosts = async (pageParam: any, searchParams: any) => {
  const searchParamsObj = Object.fromEntries([...searchParams]);

  const response = await api.get(
    // `${process.env.REACT_APP_BACKEND_ROUTE}Blog/pagedPosts`,
    `Blog/pagedPosts`,
    {
      params: {
        page: pageParam,
        ...searchParamsObj, // ✅ flatten it
      },
    }
  );
  return response.data;
};

const PostList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: ["posts", searchParams.toString()],
      queryFn: ({ pageParam = 1 }) => fetchPosts(pageParam, searchParams),
      initialPageParam: 1,
      getNextPageParam: (lastPage, pages) =>
        lastPage?.data?.hasMore ? pages.length + 1 : undefined,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    });

  const allPosts = data?.pages?.flatMap((page) => page.data.posts) || [];

  // const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      {allPosts.length > 0 ? (
        <>
          {allPosts.map((post) => (
            <PostListItem
              key={post.id}
              id={post.id}
              author={post.authorName}
              coverImageURL={post.coverImgUrl}
              category={post.categoryName}
              header={post.title}
              abstract={post.abstract}
              createdAt={post.createdAt}
            />
          ))}

          {hasNextPage && !isFetchingNextPage && (
            <LoadMoreTrigger onVisible={fetchNextPage} />
          )}
        </>
      ) : (
        <div
          className="flex justify-center align-center"
          style={{
            height: "100px",
          }}
        >
          <p style={{ textAlign: "center", color: "#666", height: "auto" }}>
            პოსტები ვერ მოიძებნა
          </p>
        </div>
      )}

      {isFetchingNextPage && (
        <div style={{ textAlign: "center", padding: "1rem" }}>იტვირთება...</div>
      )}
    </>
  );
};

export default PostList;
